import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import { postEmail } from 'Redux/ducks/email-subscribe';
import store from 'Redux/store';

const Competitions = ({ competitions, competitionEntry }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Meta title={formatMessage({ id: 'competitions.title', defaultMessage: 'Competitions' })} />
      <NoIndex noFollow />

      <div className="SplitTestSwitch container">
        <h2> Competitions </h2>
        <div>
          <h4 className="mb-4">
            Competitions that have recently ended and are still active.
          </h4>

          <table className="SplitTestTable">
            <thead>
              <tr>
                <th>Competition Name</th>
                <th>Status</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>SignUp</th>
              </tr>
            </thead>
            <tbody>
              {competitions.map(competition => (
                <tr>
                  <td>{competition.name}</td>
                  <td>{competition.active ? 'Active' : 'Inactive'}</td>
                  <td>{competition.startDate}</td>
                  <td>{competition.endDate}</td>
                  <td>
                    <EmailSignUpComponent
                      competitionId={competition._id}
                      competitionEntry={competitionEntry}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const EmailSignUpComponent = ({ competitionId, competitionEntry }) => {
  const context = 'competition';
  const [email, setEmail] = useState('');

  const intl = useIntl();

  const handleChange = (event) => {
    event.preventDefault();
    setEmail(event.target.value, false);
  };

  const optinEmail = (event, emailPassed, optin) => {
    event.preventDefault();
    localStorage.setItem(`competitionSubscribedDate_${competitionId}`, Date.now());
    store.dispatch(postEmail(emailPassed, context, optin, true, null, competitionId));
  };

  const handleSubmit = (event) => {
    optinEmail(event, email, true);
  };

  const isAlreadyEntered = !!localStorage.getItem(`competitionSubscribedDate_${competitionId}`) || competitionEntry.includes(competitionId);

  return (
    <React.Fragment>
      { isAlreadyEntered ?
        <>Entered</> :
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              required
              placeholder={intl.formatMessage({ id: 'competitions.placeholder', defaultMessage: 'Enter your email' })}
              className="form-control"
              type="email"
              name="email"
              title="Enter your email address"
              enterKeyHint="send"
              aria-label="email"
              onChange={handleChange}
            />
            <span className="input-group-append">
              <button className="btn btn-primary pb-0 pt-0 pl-3 pr-3" type="submit">
                <FormattedMessage
                  id="competitions.button"
                  defaultMessage="Submit"
                />
              </button>
            </span>
          </div>
        </form>
    }
    </React.Fragment>
  );
};

const mapStateToProps =
  ({ competitions, competitionEntry }) => ({ competitions, competitionEntry });

Competitions.propTypes = {
  competitions: PropTypes.array,
};

Competitions.defaultProps = {
  competitions: [],
};

export default connect(mapStateToProps)(Competitions);
